import axios from '../base/axios';
import API_KEY from './key';

const GET_THRILLER = 'flixfrenzy/redux/GET_THRILLER';

// eslint-disable-next-line default-param-last
const thrillerReducer = (state = [], action) => {
  switch (action.type) {
    case GET_THRILLER:
      return action.payload;
    default:
      return state;
  }
};

export const getThriller = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=53`).then((res) => {
    dispatch({
      type: GET_THRILLER,
      payload: res.data,
    });
  });
};

export default thrillerReducer;
